export const ENDPOINTS = {
  MASTER: 'master',
  AREAS: 'areas',
  DEPARTMENTS: 'departments',
  ASSET_CATEGORIES: 'asset-categories',
  UNITS: 'units',
  SUBMIT_DESTINATIONS: 'submit-destinations',
  CAUSES: 'causes',
}

export const GUIDE_ENDPOINTS = {
  DEPRECIATION_FIXED_ASSET: 'tax-declaration/depreciation_fixed_asset.html',
  FIXED_ASSET_REGISTRATION: 'management_ledger/assettable01.html',
  MONTHLY_CLOSING: 'monthly/monthly_closing.html',
  CORPORATE_INCOME_TAX: 'tax-declaration/corporate-income-tax.html',
  SETTING_LEDGER: 'config/config_ledger.html ',
  SETTING_AUTO_JOURNAL: 'config/rules.html',
  SETTING_IMPORT: 'config/migration.html',
  MASTER_ASSET_CATEGORIES: 'master_config/asset_subject.html',
  DEPRECIATION_EXPENSE_SUMMARY_TABLE: 'report/depreciation.html',
  SETTING_ACCOUNTING_PERIOD: 'config/term.html',
  FIXED_ASSET_LIST: 'management_ledger/assettable02.html',
  FIXED_ASSET_DETAIL: 'management_ledger/assettable02.html',
  MONTHLY_CLOSING_JOURNAL: 'monthly/acplus_journal.html',
  INCREASE_DECREASE_REPORT: 'report/lapsing_schedule.html',
  ASSET_EVENT_LIST_REPORT: 'report/event_list.html',
  NETSUITE_INTEGRATION: 'config/service-linkage.html',
  FIXED_ASSET_IMPORT: 'management_ledger/assettable04.html#import',
}
